/**
 * Why an item picker restricted by work category has nothing to offer. Both cases are configuration faults with
 * different remedies, so the contractor portal and field app phrase them differently rather than showing one
 * generic empty state.
 */
export enum ItemPickerRestrictionReason {
    /** No work categories resolve for the person — their own and, for a login contact, their contractor's are both empty. */
    NoWorkCategoriesForUser = 'NoWorkCategoriesForUser',

    /** The person holds work categories, but no catalogue category carries any of them. */
    NoMatchingCatalogueCategories = 'NoMatchingCatalogueCategories',
}

/**
 * The resolved item picker restriction for the current person.
 *
 * `restricted: false` means unrestricted — the caller injects no filter at all, leaving the existing query untouched.
 * It is deliberately distinct from `restricted: true` with an empty `allowedCategoryIds`, which means the person may
 * see nothing. Never collapse the two into an empty-array check.
 */
export interface ItemPickerRestriction {
    restricted: boolean;

    /**
     * Catalogue category document ids the person may pick from. Filters the categories collection by `_id` and catalogue
     * items by `category.categoryId` — the id survives a category rename, the item's copied name does not (WBS-12428).
     */
    allowedCategoryIds?: string[];

    reason?: ItemPickerRestrictionReason;
}
